import React, { useEffect, useState } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { FaUserFriends, FaRobot, FaSave, FaPlus, FaTimes, FaBolt, FaHome } from 'react-icons/fa';
import { getConfigFusion, guardarConfigFusion } from '../../servicios/ConfigFusion';
import '../home/home.css';
import './configuracion.css';

export default function Configuracion() {
    const [asesoras, setAsesoras] = useState([]);
    const [disponibles, setDisponibles] = useState([]);
    const [agregarSel, setAgregarSel] = useState(0);
    const [modoAuto, setModoAuto] = useState('fijo');
    const [autoFija, setAutoFija] = useState(0);
    const [cargando, setCargando] = useState(true);
    const [guardando, setGuardando] = useState(false);
    const [tab, setTab] = useState('fusion'); // sección activa: 'fusion' | 'dragon'

    const cargar = async () => {
        setCargando(true);
        try {
            const c = await getConfigFusion();
            setAsesoras(c.asesoras || []);
            setDisponibles(c.disponibles || []);
            setModoAuto(c.modo_auto || 'fijo');
            setAutoFija(Number(c.auto_fija_gestor) || 0);
        } catch (ex) { toast.error(ex.message); }
        finally { setCargando(false); }
    };
    useEffect(() => { cargar(); /* eslint-disable-next-line */ }, []);

    const toggle = (gestor_id, campo) => {
        setAsesoras((prev) => prev.map((a) => a.gestor_id === gestor_id ? { ...a, [campo]: a[campo] ? 0 : 1 } : a));
    };

    const agregar = () => {
        const g = Number(agregarSel);
        if (!g) return;
        const item = disponibles.find((d) => d.gestor_id === g);
        if (!item) return;
        setAsesoras((prev) => [...prev, { gestor_id: g, agent: item.agent, en_manual: 1, en_automatico: 0, orden: prev.length + 1, recibe_leads: item.recibe_leads || 0 }]);
        setDisponibles((prev) => prev.filter((d) => d.gestor_id !== g));
        setAgregarSel(0);
    };

    const quitar = (a) => {
        setAsesoras((prev) => prev.filter((x) => x.gestor_id !== a.gestor_id));
        setDisponibles((prev) => [...prev, { gestor_id: a.gestor_id, agent: a.agent, recibe_leads: a.recibe_leads || 0 }].sort((x, y) => x.agent.localeCompare(y.agent)));
        if (autoFija === a.gestor_id) setAutoFija(0);
    };

    // Asesoras marcadas "Automático" (pool del automático).
    const autoPool = asesoras.filter((a) => a.en_automatico);

    const guardar = async () => {
        if (modoAuto === 'fijo' && !autoFija) { toast.warn('Elige a qué asesora va el automático (modo Fija).'); return; }
        if (modoAuto !== 'fijo' && autoPool.length === 0) { toast.warn('Marca al menos una asesora como "Automático".'); return; }
        setGuardando(true);
        try {
            await guardarConfigFusion({ asesoras, modo_auto: modoAuto, auto_fija_gestor: modoAuto === 'fijo' ? autoFija : 0, usar_config: true });
            toast.success('Configuración guardada');
        } catch (ex) { toast.error(ex.message); }
        finally { setGuardando(false); }
    };

    return (
        <div className="home-wrap cfg-page">
            <ToastContainer position="top-right" autoClose={4000} />

            {/* ---- Pestañas: Fusión / Dragon ---- */}
            <div className="cfg-tabs" role="tablist">
                <button
                    role="tab"
                    className={`cfg-tab ${tab === 'fusion' ? 'activo' : ''}`}
                    onClick={() => setTab('fusion')}
                >
                    <FaBolt /> Configuración Fusión
                </button>
                <button
                    role="tab"
                    className={`cfg-tab ${tab === 'dragon' ? 'activo' : ''}`}
                    onClick={() => setTab('dragon')}
                >
                    <FaHome /> Configuración Dragon
                </button>
            </div>

            {tab === 'dragon' && (
                <section className="lead-card">
                    <div className="lead-card__body cfg-dragon-vacio">
                        <FaHome className="cfg-dragon-vacio__ico" />
                        <strong>Aún no hay configuración para Lead Dragon</strong>
                        <p className="cfg-sub" style={{ margin: 0 }}>
                            Hoy los leads de Dragon se asignan directamente desde el CRM Dragon,
                            no desde esta pantalla. Esta sección queda reservada para cuando
                            se habilite la configuración de reparto de Dragon.
                        </p>
                    </div>
                </section>
            )}

            {tab === 'fusion' && (<>
            {/* ---- Modo automático ---- */}
            <section className="lead-card cfg-card-modo">
                <div className="lead-card__header">
                    <span className="lead-card__title-wrap"><FaRobot />
                        <span className="lead-card__title">Modo del reparto automático</span></span>
                </div>
                <div className="lead-card__body">
                    <div className="cfg-modos">
                        <label className={`cfg-modo ${modoAuto === 'fijo' ? 'activo' : ''}`}>
                            <input type="radio" name="modo" checked={modoAuto === 'fijo'} onChange={() => setModoAuto('fijo')} />
                            <div><strong>Fija</strong><small>Siempre a una asesora</small></div>
                        </label>
                        <label className={`cfg-modo ${modoAuto === 'rotativo' ? 'activo' : ''}`}>
                            <input type="radio" name="modo" checked={modoAuto === 'rotativo'} onChange={() => setModoAuto('rotativo')} />
                            <div><strong>Rotativa (1 a 1)</strong><small>Reparte en orden entre las "Automático"</small></div>
                        </label>
                        <label className={`cfg-modo ${modoAuto === 'menor_carga' ? 'activo' : ''}`}>
                            <input type="radio" name="modo" checked={modoAuto === 'menor_carga'} onChange={() => setModoAuto('menor_carga')} />
                            <div><strong>Menor carga</strong><small>A la que tenga menos leads</small></div>
                        </label>
                    </div>

                    {modoAuto === 'fijo' && (
                        <label className="cfg-fija">
                            <span>Asignar siempre a:</span>
                            <select value={autoFija} onChange={(e) => setAutoFija(Number(e.target.value))}>
                                <option value={0}>Elige una asesora…</option>
                                {asesoras.map((a) => <option key={a.gestor_id} value={a.gestor_id}>{a.agent}</option>)}
                            </select>
                        </label>
                    )}
                </div>
            </section>

            {/* ---- Pool de asesoras ---- */}
            <section className="lead-card">
                <div className="lead-card__header">
                    <span className="lead-card__title-wrap"><FaUserFriends />
                        <span className="lead-card__title">Asesoras para asignar</span></span>
                </div>
                <div className="lead-card__body">
                    <div className="table-responsive cfg-tabla-scroll">
                        <table className="table lead-table align-middle mb-0">
                            <thead>
                                <tr><th>Asesora</th><th style={{ width: 150 }}>Recibe leads</th><th style={{ width: 110, textAlign: 'center' }}>Manual</th><th style={{ width: 110, textAlign: 'center' }}>Automático</th><th style={{ width: 60 }}></th></tr>
                            </thead>
                            <tbody>
                                {asesoras.map((a) => (
                                    <tr key={a.gestor_id}>
                                        <td className="fw-semibold">{a.agent}</td>
                                        <td>
                                            {a.recibe_leads
                                                ? <span className="cfg-badge cfg-badge--ok">Sí recibe</span>
                                                : <span className="cfg-badge cfg-badge--no" title="Está activa en Dragon pero no habilitada en el control de asignación (phonecontrols). Hoy no le llegarían leads.">No recibe</span>}
                                        </td>
                                        <td style={{ textAlign: 'center' }}>
                                            <label className="cfg-switch">
                                                <input type="checkbox" checked={!!a.en_manual} onChange={() => toggle(a.gestor_id, 'en_manual')} />
                                                <span className="cfg-slider"></span>
                                            </label>
                                        </td>
                                        <td style={{ textAlign: 'center' }}>
                                            <label className="cfg-switch">
                                                <input type="checkbox" checked={!!a.en_automatico} onChange={() => toggle(a.gestor_id, 'en_automatico')} />
                                                <span className="cfg-slider"></span>
                                            </label>
                                        </td>
                                        <td style={{ textAlign: 'center' }}>
                                            <button className="cfg-quitar" title="Quitar del equipo" onClick={() => quitar(a)}><FaTimes /></button>
                                        </td>
                                    </tr>
                                ))}
                                {asesoras.length === 0 && (
                                    <tr><td colSpan="5" className="text-center lead-empty">{cargando ? 'Cargando…' : 'Aún no hay asesoras en el equipo. Agrega una abajo.'}</td></tr>
                                )}
                            </tbody>
                        </table>
                    </div>

                    <div className="cfg-agregar">
                        <FaPlus className="cfg-agregar__ico" />
                        <select value={agregarSel} onChange={(e) => setAgregarSel(Number(e.target.value))} disabled={disponibles.length === 0}>
                            <option value={0}>{disponibles.length ? 'Agregar asesora de Dragon…' : 'No hay más asesoras activas'}</option>
                            {disponibles.map((d) => <option key={d.gestor_id} value={d.gestor_id}>{d.agent}{d.recibe_leads ? '' : '  ·  (no recibe leads)'}</option>)}
                        </select>
                        <button className="btn cfg-agregar__btn" onClick={agregar} disabled={!agregarSel}>Agregar</button>
                    </div>
                </div>
            </section>

            <div className="cfg-actions">
                <button className="btn lead-btn-primary cfg-save" onClick={guardar} disabled={guardando || cargando}>
                    <FaSave /> {guardando ? 'Guardando…' : 'Guardar configuración'}
                </button>
            </div>
            </>)}
        </div>
    );
}
